export interface Ctx {
  headers?: Record<string, unknown>
  [k: string]: unknown
}

type Fn = (ctx: Ctx, ...args: unknown[]) => unknown | Promise<unknown>

export default () =>
  (_name: string, fn: Fn): Fn => {
    return async (ctx, ...args) => {
      // process context headers
      if (!ctx.headers) {
        ctx.headers = {}
      }
      ctx.headers = normalizeHeaders(ctx.headers)

      const v = await fn(ctx, ...args)
      return v
    }
  }

const normalizeHeaders = (headers: Record<string, unknown>): Record<string, unknown> => {
  if (!headers) return {}

  const normalized: Record<string, unknown> = {}
  for (const key in headers) {
    normalized[key.toLowerCase()] = headers[key]
  }

  return normalized
}
